/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    object, func, number, shape, string, bool, arrayOf,
} from 'prop-types';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ReactHtmlParser from 'react-html-parser';
import AddonItemsList from './AddonItemsList';

const styles = (theme) => ({
    wine: {
        width: '450px',
        margin: '15px',
    },
    select: {
        backgroundColor: theme.palette.cms?.expansionBackgroundPdp || theme.palette.select || '#646464',
        '&:hover': {
            backgroundColor: theme.palette.cms?.expansionBackgroundPdp || '#646464',
            color: theme.palette.white,
        },
        minHeight: '40px !important',
        height: '40px !important',
        position: 'relative',
    },
    addonNames: {
        fontSize: '18px',
        fontWeight: '400',
        textTransform: 'uppercase',
        fontFamily: theme.typography.fontFamily,
        color: theme.palette.white,
    },
    addonNamesMobile: {
        fontSize: '12px',
        fontWeight: '400',
        textTransform: 'uppercase',
        fontFamily: theme.typography.fontFamily,
        color: theme.palette.white,
    },
    noMargin: {
        margin: '0px !important',
    },
    icons: {
        position: 'absolute',
        right: 15,
    },
    fullWidth: {
        width: '100%',
    },
});
class AddonItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: 'panel_0',
        };
    }

    buildImgPath = (path, name) => `${path + name}x.jpg`;

    /*
    * @description This is handling the expansion panel for show/hide addon item list
    * @param {string} panelId
    */
    handleClick = (panelId) => {
        const {
            open,
        } = this.state;
        if (open === panelId) {
            this.setState({ open: 'panel_collapse' }); // collapse the panel
        } else {
            this.setState({ open: panelId }); // expand the respective panel
        }
    };

    render() {
        const {
            classes, groups, drawer, hover, handleCounter, counter, handleAddonChange, maxAllowedAddons, selectedAddons, wineValidation, setLimitError, isMobile,
        } = this.props;
        const {
            open,
        } = this.state;
        return (
            <>
                {(groups || []).map((group, index) => (
                    <ExpansionPanel key={group.name} data-action="expansion" className={classes.noMargin} square expanded={open === `${'panel_'}${index}`} onChange={() => { this.handleClick(`${'panel_'}${index}`); }}>
                        <ExpansionPanelSummary className={classes.select}  data-action="expansion" aria-controls={`${'panel_'}${index}${'_content'}`}>
                            <Typography
                                component="span"
                                variant="body2"
                                className={isMobile ? classes.addonNamesMobile : classes.addonNames}
                                color="textPrimary"
                                data-action="expansion"
                            >
                                {ReactHtmlParser(group.name)}
                                <span className={classes.icons} data-action="expansion">{open === `${'panel_'}${index}` ? <ExpandMore /> : <ExpandLess />}</span>
                            </Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails data-action="expansion">
                            <Typography
                                className={classes.fullWidth}
                                data-action="expansion"
                            >
                                {(group?.addons || []).map((addons) => (
                                    <AddonItemsList
                                        key={addons.partNumber}
                                        options={addons}
                                        drawer={drawer}
                                        hover={hover}
                                        counter={counter}
                                        handleCounter={handleCounter}
                                        handleAddonChange={handleAddonChange}
                                        maxAllowedAddons={maxAllowedAddons}
                                        selectedAddons={selectedAddons}
                                        wineValidation={wineValidation}
                                        setLimitError={setLimitError}
                                        isMobile={isMobile}
                                    />
                                ))}
                            </Typography>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                ))}
            </>
        );
    }
}
AddonItem.propTypes = {
    classes: object.isRequired,
    counter: number.isRequired,
    handleCounter: func,
    hover: func,
    drawer: func,
    groups: arrayOf(shape({
        name: string.isRequired,
        maxAllowedAddons: number.isRequired,
        addons: arrayOf(shape({
            id: string.isRequired,
            shortDescription: string,
            name: string.isRequired,
        })),
    })).isRequired.isRequired,
    handleAddonChange: func,
    maxAllowedAddons: number.isRequired,
    selectedAddons: arrayOf(shape({
        name: string,
        partNumber: string,
        id: string,
    })),
    wineValidation: shape({
        wineAvailability: arrayOf({
            isProductAvailable: bool,
        }),
    }),
    setLimitError: func.isRequired,
    isMobile: bool,
};

AddonItem.defaultProps = {
    drawer: () => {},
    handleCounter: () => {},
    hover: () => {},
    handleAddonChange: () => {},
    selectedAddons: [],
    wineValidation: null,
    isMobile: false,
};
export default (withStyles(styles)(AddonItem));
